import { render, staticRenderFns } from "./PoliticaPrivacidad.vue?vue&type=template&id=65d18928&scoped=true&"
import script from "./PoliticaPrivacidad.vue?vue&type=script&lang=js&"
export * from "./PoliticaPrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./PoliticaPrivacidad.vue?vue&type=style&index=0&id=65d18928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d18928",
  null
  
)

export default component.exports